import React from 'react';
import styled from 'styled-components';
import useBannerTrabajeConNosotros from '../hooks/parameter/useBannerTrabajeConNosotros.js';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  // padding: 7vh 0;
  width: 100%;
  // background-color: orange;

  p {
    text-align: center;
    // width: 80%;
    padding: 2rem 5rem;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageTrabajeConNosotros = () => {
  const { bannerTrabajeConNosotros } = useBannerTrabajeConNosotros();
  const bodyHTML =
    bannerTrabajeConNosotros.length > 0 &&
    bannerTrabajeConNosotros[0].texto_completo;

  return (
    <DivContainer id='contBodyHTML'>
      <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
    </DivContainer>
  );
};
